// extracted by mini-css-extract-plugin
export var price = "ProductPrice_price__e23hl";
export var retailPrice = "ProductPrice_retailPrice__gBntx";